module.exports = __webpack_public_path__ + "26fbf7659bc38ad57cd7abd78ff4a797.png";